import React, { useRef } from 'react';
import classNames from 'classnames';
import Quote from '../quote/quote.component';
import styles from './quote-block.module.scss';
import { QuoteBlockSideEnum, QuoteBlockInterface } from './quote-block.interface';
import useIntersection from '../../hooks/use-intersection';

const QuoteBlock: React.FunctionComponent<QuoteBlockInterface> = ({
  className,
  side = QuoteBlockSideEnum.LEFT,
  hasBottomBorder = false,
  children,
  ...props
}) => {
  const asideRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const isAsideVisible = useIntersection({
    ref: asideRef,
    options: {
      rootMargin: '-70px 0px',
    },
  });

  return (
    <article
      className={classNames(
        styles.component,
        {
          [styles.hasAside]: children,
          [styles.isFromRight]: side === QuoteBlockSideEnum.RIGHT,
          [styles.isTextAside]: typeof children === 'string',
          [styles.isAsideVisible]: isAsideVisible,
          [styles.hasBottomBorder]: hasBottomBorder,
        },
      )}
    >
      {children && (
        <aside
          ref={asideRef}
          className={classNames(
            styles.aside,
          )}
        >
          <div className={styles.asideContent}>{children}</div>
        </aside>
      )}

      <Quote
        className={styles.quote}
        {...props}
      />
    </article>
  );
};

export default QuoteBlock;
